import React, {Fragment} from 'react';
import fetch from 'node-fetch';
import {BigTable ,Stand} from '../BigTable';
import $ from 'jquery';
import * as d3Dsv from 'd3-dsv';
const { dsvFormat } = d3Dsv;
const apidata = {
  "minTemp": {
      "station_id": "5792",
      "timestamp": "2019-02-03T00:00:00Z",
      "value": -18.6
    },
    "maxTemp": {
      "station_id": "6217",
      "timestamp": "2019-02-27T00:00:00Z",
      "value": 21.7
    },
    "maxSchnee": {
      "station_id": "5792",
      "timestamp": "2019-02-04T06:00:00Z",
      "value": 460
    },
    "all_averages": [
      -1.2,
      0.2,
      1,
      0.4,
      -0.4,
      0,
      0.2,
      1.5,
      4.4,
      6,
      5.7,
      3.1,
      2.1,
      3.1,
      3.5,
      4.5,
      5.5,
      5.6,
      5.6,
      5.1,
      5,
      6.4,
      5.6,
      1.8,
      3.3,
      5.5,
      6.6,
      7.4,
      7.9
    ],
    "stand": "2019-02-27",
    "grabbed_at": "2019-02-28T11:30:26+00:00"
}
export class CurrentWinter extends React.Component {
  constructor(props) {
    super(props);
    this.csv = dsvFormat(',');
    this.state = {
      apidata: apidata,
      idname: null
    };
  }
  componentDidMount() {
    $.get('data/idname.csv').done(res => {
      const data = this.csv.parse(res);
      this.setState({
        idname: data
      });
    });
  }
  render() {
    return (
      <Fragment>

        <div className="headline">
          <h2 className="subtitle">Schneechaos und T-Shirt-Wetter</h2>
          <h1 className="title"><span className="quotationmark left">»</span>Dieser Winter war erheblich zu mild<span className="quotationmark right">«</span></h1>
          <h3 className="introtext">Schnee, Eis, Nieselregen und frühlingshaftes Wetter: Wie extrem war diese Saison wirklich? Machen Sie den Vergleich zu den Wintern der letzten sechs Jahrzehnte.</h3>
        </div>

        <div className="current-winter__header layout-large">
          <div className="current-winter__header-title">Winter 2018 / 2019</div>
          {/* <div className="current-winter__header-date">
            <Stand apidata={this.state.apidata}/>
          </div> */}
        </div>
        <div className="current-winter__map layout-small">
          <div className="current-winter__map-box"><img className="current-winter__map-img" src="images/maps/2018_2019nnnn.png"/></div>
          <div className="current-winter__legend">
            <div className="current-winter__legend-title">Schneetage</div>
            <div className="current-winter__legend-items">
              <div className="current-winter__legend-item label"><span>wenig</span></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#133662'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#1f567d'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#2a7799'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#369ab7'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#46bdd5'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#74e0ee'}}></div>
              <div className="current-winter__legend-item color" style={{backgroundColor: '#d4faff'}}></div>
              <div className="current-winter__legend-item label"><span>viele</span></div>
            </div>
          </div>
        </div>

        <div className="current-winter__data layout-small">
          <BigTable apidata={this.state.apidata} idname={this.state.idname}/>
        </div>
      </Fragment>
    );
  }
}
